import { Loop } from '@mui/icons-material'

const Loader = ({ loading, className }) => {
  return <Loop style={{ height: '32px', width: '32px' }} className="spin-reverse" />
}

export default Loader
